<template>
  <v-btn
    class="py-4 text-none btn"
    block
    color="white"
    large
    v-bind="$attrs"
    v-on="$listeners"
  >
    <img class="img" :src="logo" />
    <span>Continue with {{ providerName }}</span>
  </v-btn>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    logo: {
      type: String,
      required: true,
    },
    providerName: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.btn {
  font-weight: 800;
  color: rgba(51, 51, 51, 0.87);
  font-size: 15px;
  line-height: 20px;
  text-align: center;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.24);
  border-radius: 8px;
}

.img {
  max-width: 24px;
  margin-right: 0.5rem;
}
</style>
